import React from 'react';
import { connect } from 'react-redux';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { AcDetailsInfo, Card } from 'components';

const AcDetailsContainer: React.FC<Props> = props => (props.auth ? (
  <Card
    withoutPadding
    title={props.acDetails ? props.acDetails.regionName : ''}
  >
      <AcDetailsInfo
        acId={props.auth.profile.attestationCommissionId}
        details={{
            info: props.acDetails,
            fetch: props.getAttestationCommission,
            clear: props.clearAcDetails,
        }}
        ascList={{
            info: props.ascList,
            fetch: props.getAsc,
            clear: props.clearAsc,
        }}
      />
  </Card>
) : null);

const mapState = (state: IRootState) => ({
    acDetails: state.ac.acDetails,
    ascList: state.asc.ascList,
    auth: state.auth.auth,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    getAttestationCommission: dispatch.ac.getAttestationCommission,
    clearAcDetails: dispatch.ac.clearAcDetails,
    getAsc: dispatch.asc.getAscAsync,
    clearAsc: () => dispatch.asc.setAsc(null),
    setErrorHandler: dispatch.errors.setErrorHandler,
});

export default connect(mapState, mapDispatch)(AcDetailsContainer);

type Props = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
